import React, { Suspense, lazy } from 'react';
import { Outlet } from "react-router-dom";
import Nav from './BottomNav/Nav';
import Loading from './Loading/Loading';
import Footer from './Footer/Footer';
import Contact from './Home/Contact/Contact';
import { reactLocalStorage } from 'reactjs-localstorage';

const Navbar = lazy(() => import('./Navbar/Navbar'));

export default function Layout() {

    const Language = reactLocalStorage.get("lan")

    return (
        <>
            <Suspense fallback={<Loading />}>
                <Navbar />
            </Suspense>
            <div style={Language === "en" ? { direction: "ltr" } : { direction: "rtl" }}>
                <Outlet />
            </div>
            <Nav />
            <Contact />

            <footer style={Language === "en" ? { direction: "ltr" } : { direction: "rtl" }}>
                <Footer />
            </footer>
        </>
    );
}
